module.exports = __webpack_public_path__ + "static/media/erroer_bg.961328d4.png";